module.exports = __webpack_public_path__ + "static/media/p5.c28cf8eb.png";